import React from "react";
import { useLocation } from "react-router-dom";
import LoadingCircleFacilitator from "../components/utils/LoadingCircleFacilitator";

const LoadingPage = () => {
  const location = useLocation();
  const isLearnerRoute = location.pathname.includes("/learner-dashboard");

  if (isLearnerRoute) {
    return null;
  }

  return (
    <div className="loading-content">
      <LoadingCircleFacilitator />
    </div>
  );
};

export default LoadingPage;
